import './filter-button.css';
import { h } from 'preact';

const { __ } = wp.i18n;

export default function FilterButton({ onClickHandler, numberOfFiltersActive }) {
	return (
		<button role="button" class="filter-button" onClick={onClickHandler}>
			<div class="filter-button-icon-container">
				<svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18">
					<path fill="currentColor" d="M0,14v2h6v-2H0z M0,2v2h10V2H0z M10,18v-2h8v-2h-8v-2H8v6H10z M4,6v2H0v2h4v2h2V6H4z M18,10V8H8v2H18z M12,6h2V4h4V2h-4V0h-2V6z" />
				</svg>
			</div>
			<div class="filter-button-label-container">
				<span class="filter-button-label">{__('Filters', 'real-estate-project')}</span>
				{numberOfFiltersActive > 0 ?
					<span class="filter-button-number-of-active-filters">{numberOfFiltersActive || 0}</span> : ''}
			</div>
		</button>
	);
}
